import { render, staticRenderFns } from "./pesanangratis.vue?vue&type=template&id=620b2f6c"
import script from "./pesanangratis.vue?vue&type=script&lang=js"
export * from "./pesanangratis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports